import { CategoryChart, CategoryChartEntity } from "./categoryChart.types";
import { getCategoryFromGQResult } from "./getCategoryFromGQResult";

export const getCategoryChartFromGQResult = (entities?: CategoryChartEntity[]): CategoryChart[] => {
    return (entities ?? []).map(({ category, ...rest }) => {
        return {
            category: getCategoryFromGQResult([category].filter(d => d != null))?.[0],
            ...rest
        };
    });
};
